import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onResetYes: () => void,
    onResetNo: () => void
}

class ResetConfirmation extends React.Component<IProps, {}> {
    handleResetYes = () => {
        this.props.onResetYes();
    }

    handleResetNo = () => {
        this.props.onResetNo();
    }

    render = () => {
        return (
            <Modal backdrop='static' show={this.props.show} onHide={() => null}>
                <Modal.Header>
                    <Modal.Title>Reset Chain, Cluster, Position, &amp; Status</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to reset all Chain properties for the Recipient and the Recipient's Directed Donors?
                    </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleResetYes}>Yes</Button>
                    <Button onClick={this.handleResetNo}>No</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ResetConfirmation;